import React from 'react';
import {
  makeStyles,
  Dialog,
  DialogActions,
  Button,
  Link,
} from '@material-ui/core';
import AskIcon from '../../img/ask-icn.svg';
import PostIcon from '../../img/post-icn.svg';
import useReactRouter from 'use-react-router';
import { getPostLanguage } from '../../services/authService';
import languages from '../../utils/languages';

const WomenWillDialog = ({ open, handleClose }) => {
  const classes = useStyles();
  const { history } = useReactRouter();
  const webLanguage = getPostLanguage();
  const languageText = languages[webLanguage ? webLanguage : 'en'];

  function handleClick(type) {
    const postOnWomenWill = type === 'post-on-women-will' ? true : false;
    const askYourFacilitator = type === 'ask-your-facilitator' ? true : false;
    history.push('/create-post', {
      postOnWomenWill,
      askYourFacilitator,
    });
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogActions className={classes.dialogBoxContainer}>
          <Link
            className={classes.link}
            onClick={() => handleClick('post-on-women-will')}
          >
            <Button className={classes.buttonContainer} color="primary">
              {languageText?.POST_ON_WOMENWILL}{' '}
              <img src={PostIcon} className={classes.iconSet} alt="Post Icon" />
            </Button>
          </Link>

          <Link
            className={classes.link}
            onClick={() => handleClick('ask-your-facilitator')}
          >
            <Button
              className={classes.buttonContainer}
              color="primary"
              autoFocus
            >
              {languageText?.ASK_YOUR_FACILITATOR}{' '}
              <img
                src={AskIcon}
                className={classes.iconService}
                alt="Ask Icon"
              />
            </Button>
          </Link>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  dialogBoxContainer: {
    background: 'inherit',
    display: 'block',
  },
  buttonContainer: {
    background: 'inherit',
    minWidth: '150px',
    margin: '0px 0px 10px 0px',
    color: '#000',
    display: 'flex',
  },
  iconSet: {
    width: '24px',
    marginLeft: '10px',
  },
  iconService: {
    width: '24px',
    marginLeft: '10px',
  },
  link: {
    textDecoration: 'inherit',
    '&:hover': {
      textDecoration: 'inherit',
    },
  },
}));

export default WomenWillDialog;
